<template>
    <v-card
        v-if="!isLoading"
        :loading="isLoading"
    >
        <v-card-title>Kelon</v-card-title>
        <v-card-text>{{ group.title }}</v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        period: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        group: null,
        isLoading: true,
    }),

    async created() {
        const response = await this.$apiv2.get(
            `kelon-access/group/${this.period.kelon_group_id}`
        )

        this.group = response.data
        this.isLoading = false
    },
}
</script>
